export const OWA_REFERENCE_ATTACHMENTS_ID = 'OwaReferenceAttachments';
const DISALLOWED_IDS = [
    'OWAHT',
    'OWAAM',
    OWA_REFERENCE_ATTACHMENTS_ID,
    'OwaReferenceAttachmentsEnd',
    'LPUrlAnchor',
    'LPImageAnchor',
];
export const DOWNLEVEL_CONTENT_CLASS = 'OLK-Hidden';

export default function shouldProcessLink(
    link: HTMLAnchorElement,
    hiddenReferenceAttachments: NodeListOf<Element> | Element[]
): boolean {
    if (link.id) {
        if (DISALLOWED_IDS.filter(id => link.id.indexOf(id) === 0).length > 0) {
            return false;
        }
    }

    if (link.className.indexOf(DOWNLEVEL_CONTENT_CLASS) !== -1) {
        return false;
    }

    if (!link.href) {
        return false;
    }

    if (hiddenReferenceAttachments) {
        for (let i = 0; i < hiddenReferenceAttachments.length; i++) {
            if (isDescendant(hiddenReferenceAttachments[i], link)) {
                return false;
            }
        }
    }

    return true;
}

function isDescendant(parent: Node, child: Node) {
    let node = child;
    while ((node = node.parentNode)) {
        if (node === parent) {
            return true;
        }
    }

    return false;
}
